module.exports = __webpack_public_path__ + "static/media/structure-animaliere.2471fbc0.jpg";